import React from "react";
import { useSession } from "../../../../../contexts/SessionContext";

export default function LeftSidebar() {
  const { classroom, contentId, setContentId } = useSession();
  const sections = [1, 2, 3, 4, 5].filter((number) => classroom?.Class?.["content" + number + "_url1"]);
  return <aside className="sidebarLeft shrink-0 p-md" aria-label="بخش‌های جلسه">
    <h2 className="mb-4">بخش‌های جلسه</h2>
    <ul className="flex flex-col gap-4">{sections.map((number) => <li key={number}>
      <button type="button" onClick={() => setContentId(number)} aria-current={contentId === number ? "true" : undefined}
        className={"w-full rounded-card border p-md " + (contentId === number ? "bg-primary text-white" : "bg-surface")}>
        بخش {number}
      </button>
    </li>)}</ul>
  </aside>;
}
